import React from 'react';
import styled from '@emotion/styled';
import { css, keyframes } from 'emotion';
import Transition from 'react-transition-group/Transition';
export default (function (_ref) {
  var show = _ref.show;
  var squares = Array.from({
    length: 8
  }, function (_, i) {
    return i;
  });
  return React.createElement(Transition, {
    in: show,
    timeout: 300,
    unmountOnExit: true
  }, function (status) {
    return React.createElement(LoadingWrap, {
      status: status
    }, React.createElement("div", {
      className: loadCls
    }, squares.map(function (square) {
      return React.createElement("div", {
        className: "square",
        key: square
      });
    })));
  });
});
var square = 32;
var duration = 10;
var LoadingWrap = /*#__PURE__*/styled("div", {
  target: "e12ptryu0"
})("position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;transition:opacity 300ms ease-out;opacity:", function (props) {
  switch (props.status) {
    default:
      return 1;
    case 'exited':
    case 'exiting':
      return 0;
  }
}, ";");
var squareAnimation = /*#__PURE__*/keyframes("0%{left:0;top:0}10.5%{left:0;top:0;}12.5%{left:", square, "px;top:0;}23%{left:", square, "px;top:0;}25%{left:", square * 2, "px;top:0;}35.5%{left:", square * 2, "px;top:0;}37.5%{left:", square * 2, "px;top:", square, "px;}48%{left:", square * 2, "px;top:", square, "px;}50%{left:", square, "px;top:", square, "px;}60.5%{left:", square, "px;top:", square, "px;}62.5%{left:", square, "px;top:", square * 2, "px;}73%{left:", square, "px;top:", square * 2, "px;}75%{left:0;top:", square * 2, "px;}85.5%{left:0;top:", square * 2, "px;}87.5%{left:0;top:", square, "px;}98%{left:0;top:", square, "px;}100%{left:0;top:0;}");
var hueRotate = /*#__PURE__*/keyframes("0%{filter:hue-rotate(0deg)}100%{filter:hue-rotate(360deg)}");
var loadCls = /*#__PURE__*/css("position:relative;width:", square * 3, "px;height:", square * 3, "px;transform:rotate(45deg);animation:", hueRotate, " ", duration, "s linear infinite both;.square{position:absolute;top:0;left:0;width:", square - 4, "px;height:", square - 4, "px;margin:2px;border-radius:4px;background:#07a;background:-webkit-linear-gradient(45deg,#fa0 40%,#0c9 60%);background:-o-linear-gradient(45deg,#fa0 40%,#0c9 60%);background:linear-gradient(45deg,#fa0 40%,#0c9 60%);background-size:cover;background-position:center;background-attachment:fixed;animation:", squareAnimation, " ", duration, "s ease-in-out infinite both;", Array.from({
  length: 8
}, function (_, i) {
  return "\n      &:nth-of-type(".concat(i, "){\n        animation-delay: -").concat(duration / 7 * i, "s\n      }\n    ");
}), "}");